import { SetRoutes } from 'components';
import routes from './routes';

const CompanyChildCategoriesPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default CompanyChildCategoriesPages;
